import * as React from 'react'
import { Alert, AlertTitle, Snackbar as MuiSnackbar } from '@mui/material'
import { snackbarIsVisible, snackbarMessage, snackbarType } from 'redux/reducers/snackbar/snackbar.selectors'
import { showSnackbar } from '../redux/reducers/snackbar/snackbar.actions'

import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'

export const Snackbar = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isVisible = useAppSelector(snackbarIsVisible)
  const message = useAppSelector(snackbarMessage)
  const type = useAppSelector(snackbarType)

  const onClose = (event: any, reason: any) => {
    if (reason === 'clickaway') {
      return
    }
    dispatch(showSnackbar(false))
  }

  return (
    <MuiSnackbar
      open={isVisible}
      autoHideDuration={2500}
      onClose={onClose}
      sx={{ width: { xs: '96%', md: '20%' }, maxWidth: '100vw' }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        variant="filled"
        severity={type}
        sx={{ width: '100%', color: theme.palette.common.white, fontSize: '13px' }}
        onClose={() => dispatch(showSnackbar(false))}
      >
        <AlertTitle sx={{ fontSize: '16px' }}>{t(`general.message.${type}`)}</AlertTitle>
        {message}
      </Alert>
    </MuiSnackbar>
  )
}
